import { Season } from '../../../../corelogic/domain/models/season.model';
import { UserSeasonFighter } from '../../../../corelogic/domain/models/userSeason.model';
import { isSameDay } from '../../../../corelogic/domain/utils/date.utils';
import { getAuthenticationToken } from '../../../../corelogic/state/authentication/authentication.selector';
import { getSeasons } from '../../../../corelogic/state/season/season.selector';
import { store } from '../../../../corelogic/state/store';
import {
  retrieveUserSeason,
  upsertUserSeason,
} from '../../../../corelogic/state/userSeason/userSeason.action';
import {
  getUserSeasonId,
  getUserSeasonLastUpdated,
  getUserSeasonLoading,
} from '../../../../corelogic/state/userSeason/userSeason.selector';

export const UserSeasonService = {
  // Internal function to check if the data is stale
  isDataStale(seasonId: string): boolean {
    const lastUpdated = getUserSeasonLastUpdated(store.getState());
    const currentSeasonId = getUserSeasonId(store.getState());
    const isLoading = getUserSeasonLoading(store.getState());

    // Don't update if already loading
    if (isLoading) return false;

    // Check if we need to update
    return (
      !lastUpdated ||
      currentSeasonId !== seasonId ||
      !isSameDay(lastUpdated, Date.now())
    );
  },

  retrieveUserSeason: (seasonId: string) => {
    const token = getAuthenticationToken(store.getState());
    if (!token) {
      console.warn('UserSeasonService: No authentication token found');
      return;
    }

    const seasons = getSeasons(store.getState());
    if (!seasons || seasons.length === 0) {
      console.warn('UserSeasonService: No seasons loaded');
      return;
    }

    const selectedSeasonData = seasons.find(
      (season: Season) => season.seasonId === seasonId,
    );

    if (!selectedSeasonData) {
      console.warn(`UserSeasonService: Season ${seasonId} not found`);
      return;
    }

    if (UserSeasonService.isDataStale(seasonId)) {
      store.dispatch(
        retrieveUserSeason({
          token,
          seasonId,
          retry: 0,
        }),
      );
    }
  },

  upsertUserSeason: (seasonId: string, fighters: UserSeasonFighter[]) => {
    const token = getAuthenticationToken(store.getState());
    if (!token) {
      console.warn('UserSeasonService: No authentication token found');
      return;
    }

    store.dispatch(
      upsertUserSeason({
        token,
        seasonId,
        fighters,
        retry: 0,
      }),
    );
  },
};
